import { Directive, Input } from '@angular/core';
import { ControlContainer, NgControl } from '@angular/forms';

@Directive({
  selector: `
  [formControl][appFormCcpDisabled],
  [formControlName][appFormCcpDisabled],
  `,
  standalone: true
})
export class FormCcpDisabledDirective {
  @Input('appFormCcpDisabled') set disabledIf(condtion: boolean) {
    const control = this.ngControl.control;

    condtion ? control?.disable() : control?.enable();
  }

  constructor(private ngControl: NgControl) { }

}

@Directive({
  selector: `
  [formGroup][appFormCcpDisabled],
  [formGroupName][appFormCcpDisabled],
  [formArrayName][appFormCcpDisabled],
  `,
  standalone: true
})

export class ContainerFormCcpDisabledDirective {
  @Input('appFormCcpDisabled') set disabledIf(condtion: boolean) {
    const container = this.controlContainer.control;


    condtion ? container?.disable() : container?.enable();
  }

  constructor(private controlContainer: ControlContainer) { }

}
